<template>
  <div>
    <naj-box :title="local.caseRelatedRequest.liftTravelPreventionRequest.title">
      <v-row>
        <v-col cols="6">
          <naj-input
            v-if="isViewMode && formModel.defendantSocialId && !formModel.decisionId"
            :type-id="formFieldType.selectbox"
            :value.sync="formModel.defendantSocialId"
            :label="local.caseRelatedRequest.liftTravelPreventionRequest.defendantName"
            :items="defendantsHaveTravelPreventionDecisions"
            item-value="identityNumber"
            item-text="name"
            validates="required"
            :disabled="isViewMode"
          ></naj-input>
          <naj-input
            v-else
            :type-id="formFieldType.selectbox"
            :value.sync="formModel.decisionId"
            :label="local.caseRelatedRequest.liftTravelPreventionRequest.travelPreventionDecisionNumber"
            :items="casePartiesHaveTravelPreventionDecisions"
            item-value="decisionId"
            item-text="decisionNumber"
            validates="required"
            :disabled="isViewMode"
            @change="defendantSocialIdChanged"
          ></naj-input>
        </v-col>
      </v-row>
    </naj-box>
  </div>
</template>

<script>
import { mode, socialIdentityTypeEnum, countriesEnum, casePartyRoleEnum } from '@/helpers/enum';
import { createNamespacedHelpers } from 'vuex';
const { mapState: mapGlobalState } = createNamespacedHelpers('GlobalModule');
const { mapActions } = createNamespacedHelpers('CasesModule');

export default {
  name: 'LiftTravelPreventionRequest',
  inject: ['$validator'],
  components: {},
  props: {
    formModel: {
      type: Object,
      default: () => ({}),
    },
    requiredData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      caseParties: [],
      casePartiesHaveTravelPreventionDecisions: [],
      selectedParties: [],
    };
  },
  computed: {
    ...mapGlobalState(['userInfo']),
    defendants() {
      return (this.caseParties || []).filter((cp) => cp.casePartyRole == casePartyRoleEnum.defendant);
    },
    defendantsHaveTravelPreventionDecisions() {
      const result = (this.defendants || []).filter((cp) =>
        this.casePartiesHaveTravelPreventionDecisions.some((td) => td.socialId == cp.socialId),
      );
      return result;
    },
    isViewMode() {
      return this.formModel && this.formModel.mode === mode.view;
    },
    isEditMode() {
      return this.formModel && this.formModel.mode === mode.update;
    },
    isNewMode() {
      return this.$route.params.requestObjectKey === 'new';
    },
  },
  watch: {},
  mounted() {
    if (this.formModel) {
      this.readCurrentUserInfo();
    }
    const params = {
      isPega: this.formModel.isPega,
      objectKey: this.formModel.case.objectKey,
    };
    this.loading = true;
    this.getCaseBasicParties(params)
      .then((res) => {
        this.caseParties = res.data;
      })
      .finally(() => (this.loading = false));
    this.getCasePartiesHaveTravelPreventionDecisions(params)
      .then((res) => {
        this.casePartiesHaveTravelPreventionDecisions = res.data;
      })
      .catch(() => {})
      .finally(() => (this.loading = false));
  },
  created() {},
  methods: {
    ...mapActions(['getCaseBasicParties', 'getCasePartiesHaveTravelPreventionDecisions']),
    readCurrentUserInfo() {
      if (this.userInfo) {
        const socialTypeId = this.userInfo.socialIdType;
        this.$set(this.formModel, 'socialIdType', socialTypeId);
        this.$set(this.formModel, 'socialId', this.userInfo.socialId);
        this.$set(this.formModel, 'firstName', this.userInfo.firstName);
        this.$set(this.formModel, 'fatherName', this.userInfo.fatherName);
        this.$set(this.formModel, 'grandFatherName', this.userInfo.grandFatherName);
        this.$set(this.formModel, 'familyName', this.userInfo.familyName);
        this.$set(this.formModel, 'dateOfBirth', this.userInfo.dateOfBirth);
        this.$set(
          this.formModel,
          'nationalityCountryId',
          socialTypeId === socialIdentityTypeEnum.nationalId ? countriesEnum.saudiArabia : this.userInfo.nationalityCountryId,
        );
        this.$set(this.formModel, 'sex', this.userInfo.gender);
        this.$set(this.formModel, 'nationality', this.userInfo.nationality);
        this.$set(this.formModel, 'nationalityID', this.userInfo.nationalityID);
        this.$set(this.formModel, 'isRetrievedFromMoi', true);
        this.$set(this.formModel, 'fullName', this.userInfo.fullName);
      } else {
        this.$set(this.formModel, 'socialIdType', null);
        this.$set(this.formModel, 'socialId', null);
        this.$set(this.formModel, 'firstName', null);
        this.$set(this.formModel, 'fatherName', null);
        this.$set(this.formModel, 'grandFatherName', null);
        this.$set(this.formModel, 'familyName', null);
        this.$set(this.formModel, 'dateOfBirth', null);
        this.$set(this.formModel, 'nationalityCountryId', null);
        this.$set(this.formModel, 'sex', null);
        this.$set(this.formModel, 'nationality', null);
        this.$set(this.formModel, 'nationalityID', null);
        this.$set(this.formModel, 'isRetrievedFromMoi', false);
        this.$set(this.formModel, 'fullName', null);
      }
    },
    defendantSocialIdChanged() {
      this.$set(this.formModel, 'selectedParties', []);

      const selectedDecision =
        this.casePartiesHaveTravelPreventionDecisions.find((cp) => cp.decisionId == this.formModel.decisionId) || {};

      const selectedDefendant = this.caseParties.find((cp) => cp.identityNumber == selectedDecision.socialId && cp.casePartyId == selectedDecision.partyId) || {};

      this.selectedParties = [
        {
          id: selectedDefendant.casePartyId,
          name: selectedDefendant.name,
          socialID: selectedDefendant.socialId,
          identityType: selectedDefendant.socialIdTypeName,
          lUTIdentityTypeID: selectedDefendant.socialIDType,
          nationalityID: selectedDefendant.nationalityID,
          nationality: selectedDefendant.nationality,
        },
      ];
      this.$set(this.formModel, 'defendantSocialId', selectedDefendant.socialId);
      this.$set(this.formModel, 'selectedParties', this.selectedParties);
    },
  },
};
</script>
